import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, HostListener, Inject, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css'], styles: ['strong { color: red; }']
})
export class ConfirmationDialogComponent {

  title!: string;
  message!: string;
  btnOkText!: string;
  btnCancelText!: string;




  constructor(@Inject(DIALOG_DATA) public data: any, private _dialogRef: DialogRef,) {
    this.title = data.title;
    this.message = data.message;
    this.btnOkText = data.btnOkText;
    this.btnCancelText = data.btnCancelText;
  }
  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    // Prevent default action for specific keys, like Enter or Tab, that might trigger alerts
    if (event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();
    }
  }



  public decline() {
    this._dialogRef.close({ result: 'No' });
  }

  public accept() {
    this._dialogRef.close({ result: 'Yes' });
  }


}
